import Toast from "components/toast";
import { _goToBack } from "routers/helper";

export const onEditProductRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToBack();
};

export const onDeleteProductRes = onEditProductRes;
